module.exports = "/static/assets/37ca9e8d78728a5d63dcbe97dcc4e5f2.png";